import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import { fetchContent } from "../api";
import { Flag, Trophy, Users, X, ChevronRight } from "lucide-react";

const STAT_ICONS = [Users, Flag, Trophy];

const Racing = () => {
  const [c, setC] = useState(null);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    fetchContent("racing").then(setC).catch(() => setC(null));
  }, []);

  if (!c) return <div className="py-32 text-center text-gray-500">Loading…</div>;

  return (
    <div className="bg-white">
      <PageBanner title={c.bannerTitle} subtitle={c.bannerSubtitle} image={c.bannerImage} />

      {/* Story */}
      <section className="max-w-4xl mx-auto px-6 py-16 text-center">
        <p className="gpm-text-gold uppercase tracking-[0.3em] text-xs mb-4">{c.storyEyebrow}</p>
        <h2 className="font-serif-display text-3xl md:text-4xl font-bold gpm-text-green mb-6">{c.storyTitle}</h2>
        <div className="gpm-divider mx-auto mb-8" />
        <div className="text-gray-600 leading-relaxed text-lg space-y-5 text-left">
          {(c.storyParagraphs || []).map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </section>

      {/* Stats */}
      {(c.stats || []).length > 0 && (
        <section className="gpm-bg-green py-14">
          <div className="max-w-5xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {c.stats.map((s, i) => {
              const Icon = STAT_ICONS[i % STAT_ICONS.length];
              return (
                <div key={i}>
                  <div className="w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4 border-2 gpm-border-gold">
                    <Icon size={26} className="gpm-text-gold" />
                  </div>
                  <div className="font-serif-display text-4xl font-bold gpm-text-cream">{s.value}</div>
                  <div className="gpm-text-cream opacity-75 text-sm uppercase tracking-wide mt-1">{s.label}</div>
                </div>
              );
            })}
          </div>
        </section>
      )}

      {/* Timeline removed */}

      {/* Gallery */}
      {(c.galleryImages || []).length > 0 && (
        <section className="py-16" style={{ backgroundColor: "#f4f2ea" }}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-10">
              <p className="gpm-text-gold uppercase tracking-[0.3em] text-xs mb-3">{c.galleryEyebrow}</p>
              <h2 className="font-serif-display text-3xl md:text-4xl font-bold gpm-text-green">{c.galleryTitle}</h2>
              <div className="gpm-divider mx-auto mt-5" />
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {c.galleryImages.map((img, i) => (
                <button
                  key={i}
                  onClick={() => setLightbox(img)}
                  className={`group relative overflow-hidden ${i === 0 ? "md:col-span-2 md:row-span-2" : ""}`}
                >
                  <div className={`overflow-hidden ${i === 0 ? "aspect-square md:aspect-[4/3]" : "aspect-[4/3]"}`}>
                    <img src={img} alt={`Racing ${i + 1}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
                </button>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section className="py-16 bg-white text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="font-serif-display text-3xl font-bold gpm-text-green mb-4">{c.ctaTitle}</h2>
          <p className="text-gray-600 mb-8">{c.ctaText}</p>
          <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 text-sm font-semibold uppercase tracking-wider gpm-text-cream transition-transform hover:-translate-y-0.5" style={{ backgroundColor: "var(--gpm-green)" }}>
            Get in Touch <ChevronRight size={18} />
          </Link>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-6" onClick={() => setLightbox(null)}>
          <button className="absolute top-6 right-6 text-white/80 hover:text-white" onClick={() => setLightbox(null)}>
            <X size={30} />
          </button>
          <img src={lightbox} alt="Racing" className="max-w-full max-h-full object-contain" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
};

export default Racing;
